import {useNavigate} from 'react-router-dom';
import cn from 'classnames';
import {ISliderData} from '..';
import usePatchBannerClickCount from '../../../../services/hookService/patchBannerClickCount/usePatchBannerClickCount';
import './item.css';
interface ISliderItemProps {
  dataItem: ISliderData;
  currentIndex: number;
  isBannerHome?: boolean;
}

const SliderItem = ({
  dataItem,
  currentIndex,
  isBannerHome,
}: ISliderItemProps) => {
  const {addBannerCount} = usePatchBannerClickCount();

  const navigate = useNavigate();
  const routerHandler = () => {
    dataItem.isExternal
      ? window.location.replace(dataItem.link)
      : navigate(dataItem.link);
  };

  const handleBannerClick = () => {
    if (isBannerHome && !!dataItem?.guid) {
      addBannerCount(dataItem.guid, {
        onSuccess: () => {
          routerHandler();
        },
      });
      return;
    }

    routerHandler();
  };

  return (
    <>
      <div
        onClick={handleBannerClick}
        className="px-2 w-full min-w-full rounded-lg aspect-video"
        style={{transform: `translate(-${currentIndex * 100}%)`}}
      >
        <img
          src={dataItem.image}
          alt="slider"
          className={cn(
            'h-full !rounded-xl',
            isBannerHome && 'w-full min-w-full object-contain',
            !isBannerHome && 'w-3/5 !aspect-square mx-auto object-cover',
          )}
        />
      </div>
    </>
  );
};

export default SliderItem;
